exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".mark-disabled[data-v-523b42ca]{opacity:.4!important}.action-button-component[data-v-523b42ca]:hover{opacity:.7!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-523b42ca&scoped=true!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/buttons/UploadButtonComponent.vue
// module id = 884
// module chunks = 2